export let currentNav = {
  nav: document.getElementById('globalNav'),
  class: '',
  target: '',
  reset: ()=>{
    if(currentNav.nav.querySelector('.current')){
      currentNav.nav.querySelector('.current').classList.remove('current');
    }
  },
  init: ()=>{
    currentNav.reset();
    currentNav.class = document.getElementById('main').dataset.name;
    currentNav.target = currentNav.nav.getElementsByClassName(currentNav.class);
    currentNav.target[0].classList.add('current');
  }
}
